
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1309Dialog extends Serenity.EntityDialog<Report_1309Row, any> {
        protected getFormKey() { return Report_1309Form.formKey; }
        protected getIdProperty() { return Report_1309Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1309Row.localTextPrefix; }
        protected getNameProperty() { return Report_1309Row.nameProperty; }
        protected getService() { return Report_1309Service.baseUrl; }
        protected getDeletePermission() { return Report_1309Row.deletePermission; }
        protected getInsertPermission() { return Report_1309Row.insertPermission; }
        protected getUpdatePermission() { return Report_1309Row.updatePermission; }

        protected form = new Report_1309Form(this.idPrefix);

    }
}